import script from "./NoticeManage.vue?vue&type=script&setup=true&lang=js"
export * from "./NoticeManage.vue?vue&type=script&setup=true&lang=js"

import "./NoticeManage.vue?vue&type=style&index=0&id=4138d2a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4138d2a0"]])

export default __exports__